import React, { ComponentType } from 'react';
import ebdcoms from '../../utils/ebdcoms';

const PermissionContent = React.lazy(
  () => import(
    /* webpackChunkName: "page_exception" */
    './Content'
  ),
);

class Permission extends React.PureComponent {
  state = {
    code: null,
    traceId: '',
    data: {},
  };

  componentDidMount() {
    ebdcoms
      .asyncExcu('getUrlParams')()
      .then((urlParams) => {
        const code = sessionStorage.getItem('ebpage-no-permission-msg') || urlParams?.code || '';
        const traceId = sessionStorage.getItem('ebpage-no-permission-msg-traceId');
        let data;

        try {
          data = JSON.parse(sessionStorage.getItem('ebpage-no-permission-data') || '{}');
        } catch (error) {
          data = {};
        }

        this.setState({
          code,
          traceId,
          data,
        });
      });
  }

  render() {
    const { code, traceId, data } = this.state;
    if (code === null) {
      return null;
    }
    return (
      <PermissionContent
        weId={`${this.props.weId || ''}_ap44sy`}
        code={code || ''}
        traceId={traceId || ''}
        data={data}
      />
    );
  }
}

export default Permission as unknown as ComponentType;
